import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import { useTranslate } from "react-admin";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./FormSectionTitle.module.scss";

const styleModal = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: "760px",
	bgcolor: "background.paper",
	boxShadow: 24,
	p: 2,
	borderRadius: "3px",
};

const FormSectionTitle = (props) => {
	const translate = useTranslate();
	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	return (
		<div
			className={
				props.className
					? `${styles.container} ${props.className}`
					: styles.container
			}
		>
			<div className={styles.titleContainer}>
				<Typography
					variant="body1"
					component="div"
					className={
						props.variant === "lowercase" ? styles.subtitle : styles.title
					}
				>
					{props.title}
				</Typography>
				{props.isNew && (
					<Typography variant="body2" component="span" className={styles.isNew}>
						{translate("resources.groups.form_title.new")}
					</Typography>
				)}
				<hr className={styles.line} />
			</div>
			{(props.descriptionOne || props.descriptionTwo) && (
				<>
					{props.descriptionOne && (
						<Typography
							variant="subtitle2"
							component="div"
							className={styles.description}
						>
							{props.descriptionOne}
						</Typography>
					)}
					{props.descriptionTwo && (
						<Typography
							variant="subtitle2"
							component="div"
							className={styles.description}
						>
							{props.descriptionTwo}
						</Typography>
					)}
				</>
			)}
			{props.example && (
				<>
					<Typography
						variant="subtitle2"
						component="div"
						className={styles.example}
						onClick={handleOpen}
					>
						{translate("resources.groups.form_description.example")}
					</Typography>
					<Modal
						open={open}
						onClose={handleClose}
						aria-labelledby="modal-modal-title"
						aria-describedby="modal-modal-description"
					>
						<Box sx={styleModal}>
							<Button onClick={handleClose} className={styles.closeButton}>
								<CloseIcon fontSize="small" />
							</Button>
							<Typography
								id="modal-modal-title"
								variant="h6"
								component="div"
								className={styles.title}
							>
								{props.exampleTitle}
							</Typography>
							<hr className={styles.line} />
							<Typography
								id="modal-modal-description"
								variant="body2"
								component="div"
								sx={{ mb: 2, mt: 1 }}
								className={styles.description}
							>
								{props.exampleDescription}
							</Typography>
							<img
								src={props.exampleImageUrl}
								alt="Context example"
								width={400}
								className={styles.image}
							/>
						</Box>
					</Modal>
				</>
			)}
		</div>
	);
};

export default FormSectionTitle;
